import { render, staticRenderFns } from "./interceptFeedback.vue?vue&type=template&id=23a8e13d&scoped=true&"
import script from "./interceptFeedback.vue?vue&type=script&lang=js&"
export * from "./interceptFeedback.vue?vue&type=script&lang=js&"
import style0 from "./interceptFeedback.vue?vue&type=style&index=0&id=23a8e13d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a8e13d",
  null
  
)

export default component.exports